/**
 * Zentrale Einstellungen für das Angebot „IT-Betreuung für russischsprachige Unternehmer“.
 *
 * ┌─────────────────────────────────────────────────────────────────────┐
 * │ PLATZHALTER – vor dem Livegang anpassen:                            │
 * │   • telegramHandle   (ohne @)                                       │
 * │   • prices.*         (monatliche Pauschalen in EUR)                 │
 * │   • hourlyRate       (Stundensatz für Projekte in EUR)              │
 * └─────────────────────────────────────────────────────────────────────┘
 */
export const ruItSupportConfig = {
  // PLATZHALTER: Telegram-Benutzername ohne @
  telegramHandle: "webcodez_PLATZHALTER",

  // PLATZHALTER: monatliche Pauschalen (EUR, netto)
  prices: {
    basic: 149,
    standard: 299,
    pro: 499,
  },

  // PLATZHALTER: Stundensatz für Projekte (EUR, netto)
  hourlyRate: 95,

  // Kontaktdaten (aus der bestehenden Website übernommen)
  phone: {
    display: "0178 4912583",
    international: "+49 178 4912583",
    href: "tel:+491784912583",
  },
  email: "michael@webcodez.de",
  linkedin: "https://www.linkedin.com/in/webcodez-michael/",

  // Seit wann IT-Administrator in deutschen Unternehmen
  adminSince: 2018,

  // Partner für Fördermittel (Antragstellung). Beschreibung mit Jan abstimmen.
  partners: {
    prometheus: {
      company: "Prometheus Research",
      person: "Jan Simner",
      city: "Dresden",
      url: "https://prometheus-research.de/",
      fundingUrl: "https://prometheus-research.de/ki-foerdermittel-sachsen",
    },
  },

  // Routen des Angebots
  paths: {
    ru: "/ru",
    ruBlog: "/ru/blog",
    de: "/it-betreuung-russischsprachig",
    fundingArticleRu: "/ru/blog/subsidii-na-cifrovizaciyu-dlya-malogo-biznesa-v-germanii",
    fundingDe: "/services/foerdermittel-digitalisierung-thueringen",
  },
} as const

export const telegramUrl = `https://t.me/${ruItSupportConfig.telegramHandle}`

/** Preis als „149 €“ formatieren (ohne Nachkommastellen, geschütztes Leerzeichen). */
export function formatEuro(amount: number): string {
  return `${amount} €`
}
